export const AppRoutes = {
  Root: "/",
};

export const SystemRoutes = {
  Login: "/login",
  Logout: "/logout",
  ForgottenPassword: "/forgotten-password",
  ResetPassword: "/reset-password/:token",
  Dashboard: "/dashboard",
  Conditions: "/conditions",
  RepDetails: "/rep-details",
  Bookings: "/bookings",
  TemplateDocuments: "/template-documents",
  Travel: "/travel",
};

export const BookingRoutes = {
  Booking: (id = ":id") => `${SystemRoutes.Bookings}/${id}`,
};

// example of matching sub-route parameters
//
// export const UserRoutes = {
//   User: (id = ":id") => `${AppRoutes.Users}/${id}`
// };
